import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { styled } from '@mui/material/styles';

export const StyledFlexContainer = styled(Flex)({
  '.ruleRow': {
    gap: '12px',
    alignItems: 'center',
    marginTop: '8px'
  },
  '& .MuiButtonBase-root': {
    '& .MuiTypography-root': {
      fontWeight: '400'
    }
  },
  '& .MuiCheckbox-root': {
    width: '16px',
    height: '16px'
  }
});
